import { createCountLessonSilentMediaURL } from './count_lesson_silent_media';
// レッスン選択のタップで再生した音声・初回動画の要素を、画面遷移後も引き継ぐ。
// WebKitの再生許可は要素単位なので、種目や音源が変わっても要素自体は作り直さない。
export class CountLessonAudio {
    constructor() {
        Object.defineProperty(this, "bgm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Audio()
        });
        Object.defineProperty(this, "voice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Audio()
        });
        Object.defineProperty(this, "countdown", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Audio()
        });
        Object.defineProperty(this, "exerciseEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Audio()
        });
        Object.defineProperty(this, "restEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Audio()
        });
        Object.defineProperty(this, "video", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: document.createElement('video')
        });
        Object.defineProperty(this, "preparationURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    static prepareFromUserGesture() {
        var _a;
        (_a = CountLessonAudio.prepared) === null || _a === void 0 ? void 0 : _a.dispose();
        const audio = new CountLessonAudio();
        CountLessonAudio.prepared = audio;
        audio.prepare();
    }
    static acquire() {
        const audio = CountLessonAudio.prepared || new CountLessonAudio();
        CountLessonAudio.prepared = null;
        return audio;
    }
    get elements() {
        return [this.bgm, this.voice, this.countdown, this.exerciseEnd, this.restEnd, this.video];
    }
    prepare() {
        // API取得前でもタップ内でplay()を呼べるよう、100msの無音PCMを用意する。
        // 音声要素はmutedにせず再生し、後から実際の音源へsrcを差し替える。
        this.preparationURL = createCountLessonSilentMediaURL();
        // 映像の実URLはAPI取得後に設定する。video要素自体への再生要求はタップ内で行う。
        // 音声だけを準備しても、後から作ったvideo要素の再生許可には引き継がれない。
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.elements.forEach((element) => {
            element.src = this.preparationURL;
            void element.play().catch((error) => {
                // srcの実音源への切り替えや、ブラウザ設定による拒否は、再生画面側で扱う。
                if (error.name === 'AbortError' || error.name === 'NotAllowedError')
                    return;
                throw error;
            });
        });
    }
    dispose() {
        this.elements.forEach((element) => {
            element.pause();
            element.removeAttribute('src');
            element.load();
        });
        if (this.preparationURL) {
            URL.revokeObjectURL(this.preparationURL);
            this.preparationURL = null;
        }
    }
}
Object.defineProperty(CountLessonAudio, "prepared", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: null
});
